import { Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { Universities as UniversitiesView } from '@modules/Universities/views/Universities';

export const Universities = () => {

  return (
    <Container
      maxWidth="sm"
      disableGutters
      sx={{
        py: 3,
      }}

    >
      <ErrorBoundary>
        <UniversitiesView />
      </ErrorBoundary>
    </Container>
  );
};
